import { AppWindow } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ISoftwareUsed } from '@/redux/post/post.d';
import carbidecreate from '@/assets/software/carbidecreate.png';
import carveco from '@/assets/software/carveco.png';
import easel from '@/assets/software/easel.png';
import estlcam from '@/assets/software/estlcam.png';
import fusion360 from '@/assets/software/fusion360.png';
import lightburn from '@/assets/software/lightburn.png';
import solidworks from '@/assets/software/solidworks.png';
import vectric from '@/assets/software/vectric.png';

/**
 * The brand marks we have. MeshCam, EZ Cad, FreeCAM and Other are absent on
 * purpose — those vendors publish nothing usable, and an invented mark is worse
 * than none. Solidworks is Dassault's `3DS`, which is what solidworks.com
 * itself serves.
 */
const LOGOS: Partial<Record<ISoftwareUsed, string>> = {
  [ISoftwareUsed.CARVECO]: carveco,
  [ISoftwareUsed.VECTRIC]: vectric,
  [ISoftwareUsed.FUSION_360]: fusion360,
  [ISoftwareUsed.CARBIDE_CREATE]: carbidecreate,
  [ISoftwareUsed.EASEL]: easel,
  [ISoftwareUsed.SOLIDWORKS]: solidworks,
  [ISoftwareUsed.ESTLCAM]: estlcam,
  [ISoftwareUsed.LIGHTBURN]: lightburn,
};

/** The software's brand mark, the counterpart of ControllerLogo — so "which
 * software" carries the same visual cue everywhere in the wizard. */
export default function SoftwareLogo({
  name,
  className = 'h-6 w-6',
}: {
  name: string;
  className?: string;
}) {
  const logo = LOGOS[name as ISoftwareUsed];

  // Decorative, and `alt=""` / `aria-hidden` for a reason: either would
  // otherwise join the accessible name the E2E suite selects options by.
  if (logo) {
    return (
      <img
        src={logo}
        alt=""
        className={cn('flex-none object-contain', className)}
      />
    );
  }
  return (
    <span
      aria-hidden
      className={cn(
        'flex flex-none items-center justify-center rounded bg-muted text-muted-foreground',
        className
      )}
    >
      <AppWindow className="h-1/2 w-1/2" />
    </span>
  );
}
